import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Article from "@/pages/article/page";
import PillarPage from "@/pages/pillar/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/allchinabuy-spreadsheet-guide",
    element: <Article />,
  },
  {
    path: "/guide/:slug",
    element: <PillarPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;